import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import router from './router'
import store from './store/index'
import auth from './plugins/msal'

Vue.config.productionTip = false

auth.ready().finally(() => {
  new Vue({
    vuetify,
    i18n,
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
})
